import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      cloudProvider: filter.cloudProvider[0] ? filter.cloudProvider : '*',
      providerRegionName: filter.providerRegionName[0]
        ? filter.providerRegionName
        : '*',
      maintenanceStartTime: filter.maintenanceStartTime[0]
        ? filter.maintenanceStartTime
        : '*',
      maintenanceEndTime: filter.maintenanceEndTime[0]
        ? filter.maintenanceEndTime
        : '*',
      customerIdsCount: {
        from: filter.customerIdsCount.from ? filter.customerIdsCount.from : '*',
        to: filter.customerIdsCount.to ? filter.customerIdsCount.to : '*'
      },
      networkIdsCount: {
        from: filter.networkIdsCount.from ? filter.networkIdsCount.from : '*',
        to: filter.networkIdsCount.to ? filter.networkIdsCount.to : '*'
      },
      gatewayIdsCount: {
        from: filter.gatewayIdsCount.from ? filter.gatewayIdsCount.from : '*',
        to: filter.gatewayIdsCount.to ? filter.gatewayIdsCount.to : '*'
      },
      maintenanceStatus: filter.maintenanceStatus[0]
        ? filter.maintenanceStatus
        : '*',
      alertCreatedAt: periodFormat(filter.alertCreatedAt)
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
